(function ($) {

  var initializeBlock = function ($block) {
    $('#changelogsearch').keyup(function(event) {
      var value = this.value
      value = value.toLowerCase()

      if (value.length > 0) {
        $('.changelogItem').removeClass('active')
        $('.changelogFilters-checkbox').prop( "checked", false)
        $('#all.changelogFilters-checkbox').prop( "checked", true)

        $('.changelogItem-title').each(function(index, el) {
          var text = $(this).text().toLowerCase()

          if (text.indexOf(value) >= 0) {
            $(this).closest('.changelogItem').addClass('active')
          }
        });

        $('.changelogItem-short_description p').each(function(index, el) {
          var text = $(this).text().toLowerCase()

          if (text.indexOf(value) >= 0) {
            $(this).closest('.changelogItem').addClass('active')
          }
        });
      } else {
        $('.changelogItem').removeClass('active')
        $('.changelogFilters-checkbox').prop( "checked", false)
        $('.changelogFilters-checkbox').trigger('change')
      }
    });

    $('.changelogFilters-checkbox').change(function(event) {
      var type = $(this).attr('value');

      if (type == 'all') {
        if($(this).is(":checked")) {
          $('.changelogItem').addClass('active')
          $('.changelogFilters-checkbox').prop( "checked", false)
          $(this).prop( "checked", true)
        } else {
          $(this).prop( "checked", true)
        }
      } else {
        $('#all.changelogFilters-checkbox').prop( "checked", false)
        $('.changelogItem').removeClass('active')

        var $checkboxes = $('.changelogFilters-checkbox:checkbox:checked')

        if ($checkboxes.length == 0) {
          $('.changelogItem').addClass('active')
          $('.changelogFilters-checkbox').prop( "checked", false)
          $('#all.changelogFilters-checkbox').prop( "checked", true)
        } else {
          if ($(this).closest('.changelog').first().hasClass('orLogic')) {
            $checkboxes.each(function(index, el) {
              var elementtype = $(this).attr('value');
              $('.changelogItem.' + elementtype).addClass('active')
            });
          } else {
            var checkedItems = new Array()

            $checkboxes.each(function(index, el) {
              checkedItems.push('.' + $(this).attr('value'));
            });

            var targets = checkedItems.join('')

            $('.changelogItem').each(function(index, el) {
              if ($(this).is(targets)) {
                $(this).addClass('active')
              }
            });
          }
        }
      }
    });
  }

  $(document).ready(function () {
    $('.block--press').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=press', initializeBlock);
  }

})(jQuery);
